import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import httpClient from '../../services/httpClient';
import { Container, Form, Input, Button, Title, Message, InfoText, BackButton } from './styles';

export default function PasswordRecovery() {
    const [email, setEmail] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [status, setStatus] = useState(null); // null | 'success' | 'error'
    const navigate = useNavigate();

    async function handleSubmit(event) {
        event.preventDefault();
        setIsLoading(true);

        try {
            const response = await httpClient.post(`/usuarios/recuperar?email=${encodeURIComponent(email)}`);
            
            if (response.ok) {
                setStatus('success');
            } else {
                setStatus('error');
            }
        } catch (error) {
            setStatus('error');
        } finally {
            setIsLoading(false);
        }
    }

    function handleBackToLogin() {
        navigate('/');
    }

    if (status === 'success') {
        return (
            <Container>
                <Title>E-mail enviado!</Title>
                <Message>
                    Um e-mail foi enviado para <strong>{email}</strong> com as instruções 
                    para recuperação da sua senha.
                </Message>
                <InfoText>
                    Verifique sua caixa de entrada e siga as instruções para definir 
                    ou redefinir sua senha.
                </InfoText>
                <Button type="button" onClick={handleBackToLogin}>
                    Voltar para o login
                </Button>
            </Container>
        );
    }

    if (status === 'error') {
        return (
            <Container>
                <Title>Erro na recuperação</Title>
                <Message $error>
                    Não foi possível recuperar a conta no momento. 
                    Por favor, tente novamente mais tarde.
                </Message>
                <Button type="button" onClick={handleBackToLogin}>
                    Voltar para o login
                </Button>
                <BackButton type="button" onClick={() => setStatus(null)}>
                    Tentar novamente
                </BackButton>
            </Container>
        );
    }

    return (
        <Container>
            <Title>Recuperar senha</Title>
            <InfoText>
                Informe seu e-mail para receber as instruções de recuperação de senha. 
                Este processo também pode ser usado para definir a senha de colaboradores 
                ou empresas cadastradas previamente.
            </InfoText>
            <Form onSubmit={handleSubmit}>
                <Input
                    placeholder="Digite seu e-mail"
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                />
                <Button type="submit" disabled={isLoading}>
                    {isLoading ? 'Enviando...' : 'Enviar instruções'}
                </Button>
            </Form>
            <BackButton type="button" onClick={handleBackToLogin}>
                Voltar para o login
            </BackButton>
        </Container>
    );
}
